module.exports = __webpack_public_path__ + "static/pubsec-section-1-img-17727968b5ab8f1036bc541115a501c8.png";